// THE "when" of a moment in the user's locale: day and short month, clock
// time, or both. Before #336 four places built their own Intl formatter for
// it (StaleBadge, the logger timeline, the editor's save line); this is the
// one copy. '' for an unparseable instant, so a caller never prints NaN.
// Formatters are cached per locale and shape: building one loads ICU data.

export type WhenParts = { date?: boolean; time?: boolean };

const cache = new Map<string, Intl.DateTimeFormat | null>();

function formatter(locale: string, { date, time }: WhenParts): Intl.DateTimeFormat | null {
  const key = `${locale}|${date ? "d" : ""}${time ? "t" : ""}`;
  if (!cache.has(key)) {
    try {
      cache.set(
        key,
        new Intl.DateTimeFormat(locale, {
          ...(date ? { day: "2-digit", month: "short" } : {}),
          ...(time ? { hour: "2-digit", minute: "2-digit" } : {}),
        }),
      );
    } catch {
      cache.set(key, null);
    }
  }
  return cache.get(key) ?? null;
}

export function formatWhen(at: Date | number | string, locale: string, parts: WhenParts): string {
  const d = at instanceof Date ? at : new Date(at);
  if (Number.isNaN(d.getTime())) return "";
  return formatter(locale, parts)?.format(d) ?? "";
}
